/**
 * sessionStorage에 값을 저장하는 util
 */

export default {
  get: (key) => {
    return sessionStorage.getItem(key)
  },
  set: (key, stringData) => {
    if (typeof stringData !== 'string') {
      console.error('sessionStore [error]:', 'string Data is not string. only string.')
    } else {
      sessionStorage.setItem(key, stringData)
    }
  },
  remove: (key) => {
    sessionStorage.removeItem(key)
  },
  getObject: (key) => {
    let data = sessionStorage.getItem(key)
    let json = {}
    if (data === undefined) {
      console.error('sessionStore [error]:', "don't have data")
    } else {
      try {
        json = JSON.parse(data)
      } catch (e) {
        console.error('sessionStore [error]:', 'data is not json format.', data)
      }
    }
    return json
  },
  setObject: (key, jsonObj) => {
    if (typeof jsonObj !== 'object') {
      console.error('sessionStore [error]:', 'jsonObj is not object. only json.')
    } else {
      sessionStorage.setItem(key, JSON.stringify(jsonObj))
    }
  }
}
